import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { ThemeProp, WithTheme } from '../../../../../../theme/Themes';
import IconButton from '../../../../../Button/IconButton';
import { getIconStroke, NavigationItemProps } from '../AppDrawerContent/AppDrawerContent.styles';

type CollapsedNavigationButtonProps = NavigationItemProps;

export const StyledIconContainer = styled.div`
  position: relative;
  width: 2.74rem;
  height: 2.74rem;

  &:hover {
    background: ${({ theme }: ThemeProp) => theme.colors.secondary['12-light-blue']};

    svg,
    path,
    circle,
    rect {
      stroke: ${({ theme }: ThemeProp) => theme.colors.greyscale.c050};
    }
  }
`;

export const StyledIconButton = styled(IconButton)`
  position: relative;
  width: 2.74rem;
  height: 2.74rem;

  &:hover {
    background: ${({ theme }: ThemeProp) => theme.colors.secondary['12-light-blue']};

    ${StyledIconContainer} {
      svg,
      path,
      circle,
      rect {
        stroke: ${({ theme }: ThemeProp) => theme.colors.greyscale.c050};
      }
    }
  }
`;

export const StyledNavLink = styled(NavLink)`
  margin-bottom: 0.5rem;
  border-radius: var(--nextui-radii-md);
  overflow: hidden;

  ${StyledIconContainer} {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.active {
    ${StyledIconContainer} {
      svg,
      path,
      circle,
      rect {
        stroke: ${({ theme }: WithTheme<CollapsedNavigationButtonProps>) => getIconStroke(true, false, theme)};
      }
    }
  }
`;
